import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { take, shareReplay } from 'rxjs/operators';

import { ApAnalyticsService, DyncontentAnalyticsData } from '@ap/analytics';

import { ApPersonalizationService } from './personalization.service';

@Component({
    selector: 'ap-personalization',
    templateUrl: 'personalization.component.html'
})
export class ApPersonalizationComponent implements OnInit, AfterViewInit {
    private readonly personalizationService = inject(ApPersonalizationService);
    private readonly analytics = inject(ApAnalyticsService);

    public showFallback = true;

    private scriptLoaded$: Observable<boolean>;

    ngOnInit(): void {
        this.scriptLoaded$ = this.personalizationService.loadPlatform().pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }

    ngAfterViewInit() {
        this.scriptLoaded$.pipe(take(1)).subscribe((loaded) => {
            if (loaded) {
                this.analytics.push(new DyncontentAnalyticsData('personalized-content', 'Loaded'));
            }
        });
    }
}
